// extracted by mini-css-extract-plugin
module.exports = {"container":"articles_container__BxQiW","pdfContainer":"articles_pdfContainer__1niJZ"};